<div class="modal-header">
    <p>{{ data.title }}</p>
    <button mat-button (click)="onClose()" class="close-btn">Close</button>
</div>

<!-- <div class="modal-content custom-vertical-scroll"> -->
<!-- <div class="ag-grid-wrapper"> -->
<ag-grid-angular
    class="ag-theme-alpine"
    [columnDefs]="data.columnDefs"
    [rowData]="data.rowData"
    [gridOptions]="gridOptions"
    style="width: 100%; height: calc(100vh - 120px); padding: 20px 20px 0px 20px"
>
</ag-grid-angular>
<!-- </div> -->
<!-- </div> -->
